import type { CustomDomainsTranslations } from '../interfaces/customDomains';

export const customDomainsTranslations: CustomDomainsTranslations = {
  eyebrow: 'Organization',
  title: 'Custom domains',
  sub: 'Serve the dashboard, the API and your emails from your company domains. Your DNS stays where it is: you only publish the records we show you.',
  disabled_title: 'Not available in this environment',
  disabled_text: 'Custom domains are not enabled here yet.',
  load_error: 'We could not load your domains. Please try again.',

  kind_frontend_title: 'Dashboard',
  kind_frontend_desc: 'Your team opens {{brand}} at, for example, app.yourcompany.com.',
  kind_backend_title: 'API',
  kind_backend_desc: 'The API, webhooks and the dashboard on your domain use, for example, api.yourcompany.com.',
  kind_email_title: 'Email',
  kind_email_desc: 'Invitations, password recovery and notifications are sent from your domain.',

  add: 'Set up',
  verify_now: 'Check now',
  retry: 'Retry',
  delete: 'Remove',
  cancel: 'Cancel',
  copy: 'Copy',
  copied: 'Copied',
  history: 'Show history',
  hide_history: 'Hide history',

  status_pending_dns: 'Waiting for DNS',
  status_provisioning: 'Setting up',
  status_active: 'Active',
  status_degraded: 'Needs attention',
  status_deleting: 'Removing',
  status_deleted: 'Removed',
  status_failed: 'Error',

  records_title: 'DNS records',
  records_intro: "Create these records at your domain's DNS provider. We check every few minutes; you can also ask for a check.",
  col_type: 'Type',
  col_name: 'Name',
  col_value: 'Value',
  col_state: 'Status',
  record_seen: 'Detected',
  record_missing: 'Pending',
  purpose_routing: 'Points your domain to {{brand}}',
  purpose_ownership: 'Proves the domain is yours',
  purpose_certificate_validation: 'HTTPS certificate issuance',
  purpose_dkim: 'DKIM signature',
  purpose_mail_from_mx: 'MAIL FROM (bounces)',
  purpose_mail_from_spf: 'MAIL FROM SPF',
  purpose_dmarc: 'DMARC policy',

  note_dns_only: 'If your DNS is on Cloudflare, create the CNAMEs as "DNS only" (grey cloud).',
  note_acm_keep: 'Do not delete the certificate record: it is used to renew it automatically.',
  note_caa: 'If your domain has CAA records, authorize amazon.com, letsencrypt.org, pki.goog and ssl.com.',
  note_dmarc: 'If your domain already has a DMARC record you do not need another one; the suggested one is a starting point.',
  note_relogin: 'Your team will need to sign in again the first time they use the new domain.',
  note_email_fallback: 'Until it is active, emails keep going out from {{brand}}.',

  last_checked: 'Last checked',
  last_error: 'Details',
  mail_from: 'Sender',
  dmarc_policy: 'DMARC policy',
  never: 'Not yet',

  dialog_title: 'Set up domain',
  dialog_desc_frontend: 'Use a subdomain (not the root domain), for example app.yourcompany.com.',
  dialog_desc_backend: 'Use a subdomain (not the root domain), for example api.yourcompany.com.',
  dialog_desc_email: 'It can be your root domain or a subdomain dedicated to email.',
  hostname_label: 'Domain',
  hostname_placeholder_frontend: 'app.yourcompany.com',
  hostname_placeholder_backend: 'api.yourcompany.com',
  hostname_placeholder_email: 'yourcompany.com',
  hostname_required: 'Enter a domain.',
  from_local_part_label: 'Address',
  from_local_part_invalid: 'Use only letters, numbers, dots, hyphens or underscores.',
  from_name_label: 'Sender name',
  from_name_help: 'What your customers see next to the address. Defaults to {{brand}}.',
  from_name_invalid: 'It cannot contain quotes or the < > signs.',
  mail_from_subdomain_label: 'MAIL FROM subdomain',
  mail_from_subdomain_help: 'Receives bounces and aligns SPF. Change it only if "mail" is already in use.',
  mail_from_subdomain_invalid: 'Use only lowercase letters, numbers and hyphens.',
  submit: 'Save and show records',

  delete_title: 'Remove this domain?',
  delete_text: 'It stops working right away and we remove its certificate and configuration. You can add it again later.',
  delete_confirm: 'Remove domain',

  toast_created: 'Domain saved. Publish the DNS records to activate it.',
  toast_deleted: 'Domain removed.',
  toast_verify: 'Check in progress.',
  toast_retry: 'Retrying the setup.',

  error_INVALID_HOSTNAME: 'That domain is not valid.',
  error_APEX_NOT_ALLOWED: 'Use a subdomain, not the root domain.',
  error_RESERVED_DOMAIN: 'That domain cannot be used.',
  error_HOSTNAME_TAKEN: 'Another organization already uses that domain.',
  error_CUSTOM_DOMAIN_KIND_EXISTS: 'You already have a domain of this type. Remove it first to change it.',
  error_CUSTOM_DOMAINS_DISABLED: 'Custom domains are not enabled in this environment.',
  error_CUSTOM_FRONTEND_UNAVAILABLE: 'A custom dashboard domain is not available for this platform.',
  error_generic: 'We could not complete the action. Please try again.',
};
